export default {
   props: {
      width: {
         type: Number,
         default: 960
      },
      height: {
         type: Number,
         default: 30
      },
      margin: {
         type: Object,
         default() {
            return { top: 0, left: 0, bottom: 0, right: 0 };
         }
      }
   },
   computed: {
      totalWidth() {
         return this.width + this.marginLeft + this.marginRight;
      },
      totalHeight() {
         return this.height + this.marginTop + this.marginBottom;
      },
      marginTop() {
         return this.margin.top;
      },
      marginLeft() {
         return this.margin.left;
      },
      marginRight() {
         return this.margin.right;
      },
      marginBottom() {
         return this.margin.bottom;
      }
   }
};
